module.exports = __webpack_public_path__ + "./images/faf4df54c0e2d575fc25f99b893d3e5b.webp";